import React, { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { baseURL } from "../../../config/api";
import { put_AccessControlByGroupName } from "../../../services/AccessControl";
import AllRoles from "./AllRoles";
import { PleasewaitPopup } from "../../../components/PleasewaitPopup";
import { Tabs } from "../../../components/Tabs";

export default function AccessControl() {
    const token = Cookies.get("token-express-tire");
    const [pages, setPages] = React.useState<any[]>([]);
    const [currentPage, setCurrentPage] = React.useState<any | null>(null);
    const [searchValue, setSearchValue] = useState<string>("");
    const [expandListGroup, setExpandListGroup] = useState<any[]>([]);
    const [pleaseWait, setPleaseWait] = useState<boolean>(false);
    const [isChange, setIsChange] = useState<number>(0);

    const handleOnClick = (page: any) => {
        setCurrentPage(page);
    };

    useEffect(() => {
        setPleaseWait(true);
        axios
            .get(`${baseURL}roles`)
            .then((response) => {
                setPages(() =>
                    response?.data
                        ?.filter((value: any) => value?.roleName?.toLowerCase()?.trim() !== "admin")
                        ?.map((item: any) => {
                            return {
                                id: item.id,
                                label: item.roleName,
                            };
                        })
                );

                const currentRole = response?.data?.find((value: any) => value?.roleName?.toLowerCase()?.trim() !== "admin");

                if (currentRole) {
                    setCurrentPage({
                        id: currentRole?.id || 0,
                        name: currentRole?.roleName || "N/A",
                    });
                }

                setPleaseWait(false);
            })
            .catch((error) => {
                setPleaseWait(false);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getExpandGroupsDetails = (expandList: any[]) => {
        setExpandListGroup(() => expandList);
    };

    const updateToNotSetAll = () => {
        if (expandListGroup.length !== 0) {
            setPleaseWait(true);
            let count = 0;
            expandListGroup.forEach(async (item: any) => {
                put_AccessControlByGroupName(item.sections[0].roleId, item.groupName, 1, token!.toString())
                    .then(() => {
                        count++;
                        if (expandListGroup.length === count) {
                            setIsChange(1);
                        }
                    })
                    .catch(() => {
                        setPleaseWait(false);
                    });
            });
        }
    };

    const updateToAllowAll = () => {
        if (expandListGroup.length !== 0) {
            setPleaseWait(true);
            let count = 0;
            expandListGroup.forEach(async (item: any) => {
                put_AccessControlByGroupName(item.sections[0].roleId, item.groupName, 2, token!.toString())
                    .then(() => {
                        count++;
                        if (expandListGroup.length === count) {
                            setIsChange(2);
                        }
                    })
                    .catch(() => {
                        setPleaseWait(false);
                    });
            });
        }
    };

    const updateToDenyAll = () => {
        if (expandListGroup.length !== 0) {
            setPleaseWait(true);
            let count = 0;
            expandListGroup.forEach(async (item: any) => {
                put_AccessControlByGroupName(item.sections[0].roleId, item.groupName, 3, token!.toString())
                    .then(() => {
                        count++;
                        if (expandListGroup.length === count) {
                            setIsChange(3);
                        }
                    })
                    .catch(() => {
                        setPleaseWait(false);
                    });
            });
        }
    };

    return (
        <div>
            <div className={`px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto`}>
                <div className="w-full bg-white p-4 rounded-md">
                    <div className="w-full flex justify-between items-center mt-2">
                        <h2 className={`text-lg font-semibold text-secondary`}>
                            Access Control
                        </h2>

                        <div className="flex items-center gap-2">
                            <input
                                type="text"
                                placeholder="Search..."
                                className="h-[30px] px-2 border border-gray-300 rounded text-sm"
                                value={searchValue}
                                onChange={(e) => setSearchValue(e.target.value)}
                            />

                            <button
                                className="h-[30px] px-3 bg-white text-gray-600 border border-gray-400 rounded text-xs font-bold capitalize hover:bg-gray-100"
                                onClick={() => updateToNotSetAll()}
                            >
                                Not Set All
                            </button>

                            <button
                                className="h-[30px] px-3 bg-green-500 text-white rounded text-xs font-bold capitalize hover:bg-green-600"
                                onClick={() => updateToAllowAll()}
                            >
                                Allow All
                            </button>

                            <button
                                className="h-[30px] px-3 bg-red-600 text-white rounded text-xs font-bold capitalize hover:bg-red-700"
                                onClick={() => updateToDenyAll()}
                            >
                                Deny All
                            </button>

                            <div
                                className="h-[30px] px-2 flex items-center bg-white text-black border-2 border-gray-300 rounded cursor-pointer hover:bg-gray-100"
                            >
                                <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                >
                                    <path d="M12 16V4" />
                                    <path d="M6 12l6 6 6-6" />
                                    <rect x="4" y="18" width="16" height="2" rx="1" />
                                </svg>

                            </div>
                        </div>
                    </div>

                    <div>
                        <Tabs
                            tabs={pages}
                            activeIndex={currentPage?.id}
                            onChange={(_, tab) => handleOnClick(tab)}
                        />

                        <div>
                            {
                                currentPage && (
                                    <AllRoles
                                        roleId={currentPage.id}
                                        searchValue={searchValue}
                                        getExpandGroupsDetails={(expandList) => getExpandGroupsDetails(expandList)}
                                        setPleaseWait={(wait) => setPleaseWait(wait)}
                                        isChange={isChange}
                                        updateToZeroChange={() => setIsChange(0)}
                                    />
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>

            <PleasewaitPopup showPopup={pleaseWait} />
        </div>
    );
}